import { render, staticRenderFns } from "./SolicitarIsencao.vue?vue&type=template&id=3095ec8c&scoped=true"
import script from "./SolicitarIsencao.vue?vue&type=script&lang=js"
export * from "./SolicitarIsencao.vue?vue&type=script&lang=js"
import style0 from "./SolicitarIsencao.vue?vue&type=style&index=0&id=3095ec8c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3095ec8c",
  null
  
)

export default component.exports